export default {
  methods: {
    failedRequestNotification() {
      this.$notify({
        type: 'error',
        text: 'Your changes were not saved. Please check that your device is connected to the Internet and try again'
      })
    }
  }
}